// Vollea — Admin Settings (invite-only + club-approval toggles)
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { IoChevronBack } from "react-icons/io5";
import { Btn, Card } from "../../components/ui-vollea";
import { api } from "../../lib/api";
import { C, SP } from "../../lib/theme";

function ToggleRow({ title, on, onChange, descOn, descOff, toggleTestid }) {
  return (
    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: SP.md }}>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ color: C.text, fontWeight: 700, fontSize: 15 }}>{title}</div>
        <div style={{ color: C.textMuted, fontSize: 13, marginTop: 2 }}>{on ? descOn : descOff}</div>
      </div>
      <button
        type="button"
        data-testid={toggleTestid}
        aria-pressed={on}
        onClick={() => onChange(!on)}
        style={{
          position: "relative", width: 50, height: 28, borderRadius: 14, flexShrink: 0,
          background: on ? C.lime : C.surface3, transition: "background 0.2s", border: "none", cursor: "pointer",
        }}
      >
        <span style={{
          position: "absolute", top: 3, left: on ? 25 : 3, width: 22, height: 22, borderRadius: 11,
          background: on ? C.onLime : C.text, transition: "left 0.2s",
        }} />
      </button>
    </div>
  );
}

export default function AdminSettings() {
  const navigate = useNavigate();
  const [inviteOnly, setInviteOnly] = useState(true);
  const [clubsRequireApproval, setClubsRequireApproval] = useState(true);
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState("");

  useEffect(() => {
    api.get("/admin/settings").then((r) => {
      setInviteOnly(!!r.invite_only);
      // Default to true if the field is missing on older docs.
      setClubsRequireApproval(r.clubs_require_approval !== false);
    }).catch(() => {});
  }, []);

  const save = async () => {
    setSaving(true); setMsg("");
    try {
      await api.put("/admin/settings", {
        invite_only: inviteOnly,
        clubs_require_approval: clubsRequireApproval,
      });
      setMsg("Settings saved");
    } catch (e) { setMsg(e.message); }
    finally { setSaving(false); }
  };

  return (
    <div style={{ background: C.bg, minHeight: "100vh", padding: `${SP.lg}px ${SP.lg}px 90px` }}>
      <button onClick={() => navigate("/admin")} data-testid="settings-admin-back" style={{ color: C.text, marginBottom: SP.md, background: "transparent", border: "none", cursor: "pointer" }}>
        <IoChevronBack size={26} />
      </button>
      <h1 style={{ color: C.text, fontWeight: 700, fontSize: 28, margin: 0, letterSpacing: 0.5 }}>Settings</h1>
      <p style={{ color: C.textMuted, fontSize: 14, marginTop: 4 }}>Platform-wide controls</p>

      <Card style={{ marginTop: SP.xl }}>
        <ToggleRow
          title="Invite-only mode"
          on={inviteOnly}
          onChange={setInviteOnly}
          descOn="New users need a valid invite code to sign up."
          descOff="Anyone can sign up without an invite code."
          toggleTestid="invite-only-toggle"
        />
      </Card>

      <div style={{ height: SP.md }} />

      <Card>
        <ToggleRow
          title="Require approval for new clubs"
          on={clubsRequireApproval}
          onChange={setClubsRequireApproval}
          descOn="New clubs created by club admins are pending until you approve them."
          descOff="New clubs are live immediately — no super-admin approval needed."
          toggleTestid="clubs-require-approval-toggle"
        />
      </Card>

      {msg ? <p data-testid="settings-msg" style={{ color: msg === "Settings saved" ? C.lime : C.error, marginTop: SP.md, fontSize: 13 }}>{msg}</p> : null}

      <div style={{ height: SP.lg }} />
      <Btn label="Save settings" loading={saving} testid="settings-save-button" onClick={save} />
    </div>
  );
}
